/*
MODIFICATION PROVIDED BY THE SEARCHANISE TEAM, WITH ANY QUESTIONS, CONTACT US AT feedback@searchanise.io

Modification replaces the search suggestions when nothing was found in the Instant search widget. 
Suggestions that will be added are contained in the customSuggestionsOnZeroResults variable in the following format:

let customSuggestionsOnZeroResults = ["Item 1", "Item 2", "Item 3"];

The number of items may vary, each item should be put inside quote marks and be separated by a comma.

You can quickly disable the modification by changing the isEnabled value from true to false.
*/

// SETTINGS START

let customSuggestionsOnZeroResults = ["Fortitude", "Curlicue", "Kyklos"];
let isEnabled = true;

// SETTINGS END, DO NOT MODIFY THE CODE BELOW

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {

      if (!isEnabled) { return }
        
        $(document).on('Searchanise.AutocompleteUpdated', function(event, input, container) {
            if ($('.snize-nothing-found', container).length) {
                $('.snize-popular-suggestions-container', container).empty();
                if (customSuggestionsOnZeroResults.length) {
                    for (let suggestion of customSuggestionsOnZeroResults) {
                        $('.snize-popular-suggestions-container', container).append(`<a class="snize-no-products-found-link" href="#" data-no-instant="true">${suggestion}</a>`);
                    }
                }
            }
        });
    })(window.Searchanise.$);
});